import { Button } from '@crowdex/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@crowdex/ui/components/dialog';

type BranchInWorktreeDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  branch: string | null;
  worktreePath: string | null;
  onOpenWorktree: () => void;
  working: boolean;
};

/**
 * Git only allows a branch to be checked out in one place. When the target
 * branch is already active in another worktree, an in-place switch is
 * impossible, so we offer to open that worktree instead of surfacing the raw
 * "already checked out" error.
 */
export function BranchInWorktreeDialog({
  open,
  onOpenChange,
  branch,
  worktreePath,
  onOpenWorktree,
  working,
}: BranchInWorktreeDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Branch is checked out elsewhere</DialogTitle>
          <DialogDescription>
            {branch ?? 'That branch'} is already checked out in another worktree
            {worktreePath === null ? '' : ` (${worktreePath})`}. Git can only check out a branch in
            one place, so open that worktree instead of switching here.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} variant="ghost">
            Cancel
          </Button>
          <Button disabled={working || worktreePath === null} onClick={() => onOpenWorktree()}>
            Open worktree
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
